import { Link } from "react-router-dom";
import { UserLabels } from "../../../utils/labels/userlabel";
import UserData from "../../../utils/mock/data";
import UserCard from "../../molecules/UserCard";
import Button from "../../atoms/Button";
import { ReactComponent as Arrow } from "../../svgs/back-arrow.svg";

const UserProducts = ({ userProducts = {} }) => {
  let { heading, bottom } = UserLabels;
  return (
    <div className="sm:w-16 md:w-64 lg:w-full">
      <Link to={"/"}>
        <Button
          varient="rounded"
          borderColor="black"
          className="w-auto justify-center px-2.5 py-2 mt-6 ml-10 text-black  bg-white border border-black  hover:bg-gray-50  "
        >
          <div className="flex">
            <Arrow className="w-5 text-black" />
            <div className="font-bold text-sm pl-1 pr-2">Back to home</div>
          </div>
        </Button>
      </Link>
      <p className=" mt-[1.5rem] text-[1.5rem] leading-[1.565rem] md:mt-[1.5rem] md:text-[1.5rem] md:leading-[1.565rem]  lg:mt-[0.5rem] text-center lg:text-[2.5rem] font-normal lg:leading-[3.1875rem] ">
        {heading}
      </p>

      <div className=" flex flex-col mx-[2.25rem] sm:my-[2rem] md:flex md:flex-col lg:mx-[10.25rem] lg:mt-[3rem] lg:grid grid-cols-3 gap-28 mt-15 ">
        {UserData.map(({ id, userTitle, description, src }) => (
          <Link to={`/${userTitle?.toLowerCase()}`} key={id}>
            <button className="">
              <div
                className="shadow hover:shadow-2xl transition duration-500 hover:scale-105 border border-blue-800 rounded-2xl hover:ease-out bg-[#E8EFF8]"
                key={id}
              >
                <UserCard
                  userTitle={userTitle}
                  description={description}
                  userImage={src}
                />
              </div>
            </button>
          </Link>
        ))}
      </div>
      <p className="mt-[5rem] mb-[3rem] text-center text-[1.5rem] font-normal leading-[1.91375rem]">
        {bottom}
      </p>
    </div>
  );
};

export default UserProducts;
